module.exports = __webpack_public_path__ + "img/basin_position_info.b3e4b3d3.svg";